const isRunningInsideAndroidWebView = function () {
  return (
    typeof window.MobileAgent === 'string' &&
    window.MobileAgent.toLowerCase() === 'android'
  );
};

const isRunningInsideiOSWebView = function () {
  return (
    typeof window.MobileAgent === 'string' &&
    window.MobileAgent.toLowerCase() === 'ios'
  );
};

export { isRunningInsideAndroidWebView, isRunningInsideiOSWebView };
